/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect} from "react"; 

export function useMountEffect(fn) {
  	useEffect(fn, []);
}

export function useUnmountEffect(fn) {
  	useEffect(() => fn, []);
}